import { render } from "./home.vue?vue&type=template&id=6b822e44"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b822e44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b822e44', __exports__)) {
    console.log('reload')
    api.reload('6b822e44', __exports__)
  }
  
  module.hot.accept("./home.vue?vue&type=template&id=6b822e44", () => {
    console.log('re-render')
    api.rerender('6b822e44', render)
  })

}


export default __exports__